import { useDispatch } from 'react-redux';
import { preChatActions } from '@/redux/modules';
import {
  XRAY_ENABLED_SUBSCRIPTIONS_IN_DIAGNOSTIC,
  XRAY_DIAGNOSTIC_ALERT_CREDIT_CUSTOMER,
} from '@/config/GrowthBook/constants';
import { useFeatureIsOn } from '@growthbook/growthbook-react';
import { useState } from 'react';
import { differenceInSeconds } from 'date-fns';
import logger from '@/utils/logger';

const useDiagnostic = () => {
  const [lastDispatch, setLastDispath] = useState(null);
  const dispatch = useDispatch();
  const enabledSubscriptionInDiagnostic = useFeatureIsOn(XRAY_ENABLED_SUBSCRIPTIONS_IN_DIAGNOSTIC);
  const enableAlertCreditRefund = useFeatureIsOn(XRAY_DIAGNOSTIC_ALERT_CREDIT_CUSTOMER);

  const requestDiagnostic = (location) => {
    let dateDiff = null;
    if (lastDispatch) {
      dateDiff = differenceInSeconds(new Date(), lastDispatch);
    }

    if (dateDiff && dateDiff <= 10) {
      logger.info(`tentativa de requisição de diagnostic em menos de 10s: '${location}'`);
    }

    if (!dateDiff || dateDiff > 10) {
      setLastDispath(new Date());
      dispatch(
        preChatActions.diagnostic.get({
          enabledSubscriptionInDiagnostic,
          enabledCloudflare: true,
          enableAlertCreditRefund,
          enabledCloudflareDelayedAlert: true,
        }),
      );
    }
  };

  return {
    requestDiagnostic,
  };
};

export default useDiagnostic;
